/**
 * Normalización de teléfonos colombianos a E.164.
 *
 * El teléfono es la llave de todo el sistema: es el id del documento en
 * `directorio` y en `contactos`. Si se guarda con formatos distintos, el mismo
 * número queda como dos clientes. Por eso esta función es la única puerta.
 */
const SOLO_DIGITOS = /\D+/g;
/**
 * Acepta lo que la gente escribe de verdad:
 *   300 123 4567 · 3001234567 · +57 300 1234567 · 57 300 123 45 67
 *   (601) 123 4567 · 601 1234567
 * y devuelve siempre 57XXXXXXXXXX.
 */
export function normalizarTelefono(entrada) {
    if (!entrada || !entrada.trim()) {
        return { ok: false, motivo: 'Escribe un número.' };
    }
    let d = entrada.replace(SOLO_DIGITOS, '');
    // Prefijo de marcación internacional escrito como 0057 o 00 57
    if (d.startsWith('0057'))
        d = d.slice(4);
    // Indicativo de país ya presente
    else if (d.length > 10 && d.startsWith('57'))
        d = d.slice(2);
    // Un 0 de larga distancia al principio
    else if (d.length === 11 && d.startsWith('0'))
        d = d.slice(1);
    if (d.length !== 10) {
        return {
            ok: false,
            motivo: d.length < 10
                ? `Faltan dígitos: van ${d.length} de 10.`
                : `Sobran dígitos: van ${d.length} de 10.`,
        };
    }
    // Celular: empieza en 3
    if (d.startsWith('3')) {
        return {
            ok: true,
            e164: `57${d}`,
            tipo: 'movil',
            visible: `${d.slice(0, 3)} ${d.slice(3, 6)} ${d.slice(6)}`,
        };
    }
    // Fijo: desde 2022 son 10 dígitos que empiezan en 60
    if (d.startsWith('60')) {
        return {
            ok: true,
            e164: `57${d}`,
            tipo: 'fijo',
            visible: `(${d.slice(0, 3)}) ${d.slice(3, 6)} ${d.slice(6)}`,
        };
    }
    return {
        ok: false,
        motivo: 'Un número colombiano empieza en 3 si es celular, o en 60 si es fijo.',
    };
}
/** Para mostrar: 573001234567 -> 300 123 4567 */
export function telefonoVisible(e164) {
    const d = e164.replace(SOLO_DIGITOS, '');
    const local = d.startsWith('57') ? d.slice(2) : d;
    if (local.length !== 10)
        return e164;
    return local.startsWith('3')
        ? `${local.slice(0, 3)} ${local.slice(3, 6)} ${local.slice(6)}`
        : `(${local.slice(0, 3)}) ${local.slice(3, 6)} ${local.slice(6)}`;
}
/** Enlace para abrir WhatsApp con ese contacto. */
export function enlaceWhatsApp(e164, texto) {
    const base = `https://wa.me/${e164.replace(SOLO_DIGITOS, '')}`;
    return texto ? `${base}?text=${encodeURIComponent(texto)}` : base;
}
